export default __webpack_public_path__ + "static/media/logo_dark.026885f2.svg";